import { type CoreJsonAPIResponse } from '../CoreJsonAPIResponse';
import { type TPandasDataFrameDict } from '../components/TPandasDataFrameDict';
import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import { type IAugmentedBackendResponse } from '../models/IAugmentedBackendResponse';
import { type ITradeOrderAccount } from '../models/ITradeOrderAccount';
import { type ICoreTableQuery } from '../models/ITradeOrdersTable';
import { type TTradeOrdersHistory } from '../models/TTradeOrdersHistory';
import CoreJsonAPIService from './CoreJsonAPIService';

export interface ITradeOrderSecurity {
  isin: string;
  companyName: string;
  securityType: string;
}

export class SvTradeOrderServices extends CoreJsonAPIService {
  public static async refreshSystemOrders(): Promise<CoreJsonAPIResponse<boolean>> {
    return await super.get<boolean>(EDjangoAppsEndpoints.tradeOrders, 'refresh');
  }

  public static async getOrders(
    fundID: string,
    query: ICoreTableQuery
  ): Promise<CoreJsonAPIResponse<IAugmentedBackendResponse<TPandasDataFrameDict>>> {
    return await super.get<IAugmentedBackendResponse<TPandasDataFrameDict>>(
      EDjangoAppsEndpoints.tradeOrders,
      `${fundID}/orders`,
      query
    );
  }

  public static async putOrders(
    data: TPandasDataFrameDict,
    query: ICoreTableQuery
  ): Promise<CoreJsonAPIResponse<IAugmentedBackendResponse<TPandasDataFrameDict>>> {
    return await super.put<IAugmentedBackendResponse<TPandasDataFrameDict>>(EDjangoAppsEndpoints.tradeOrders, 'put', {
      data,
      query
    });
  }

  public static async getHistory(lineageKey: string): Promise<CoreJsonAPIResponse<TTradeOrdersHistory>> {
    return await super.get<TTradeOrdersHistory>(EDjangoAppsEndpoints.tradeOrders, `history/${lineageKey}`);
  }

  public static async getSecuritiesByIsinList(isins: string[]): Promise<CoreJsonAPIResponse<ITradeOrderSecurity[]>> {
    return await super.get<ITradeOrderSecurity[]>(EDjangoAppsEndpoints.tradeOrders, 'securities/isin', {
      list: isins.join(',')
    });
  }

  public static async getSecurities(
    query: ICoreTableQuery
  ): Promise<CoreJsonAPIResponse<IAugmentedBackendResponse<TPandasDataFrameDict>>> {
    return await super.get<IAugmentedBackendResponse<TPandasDataFrameDict>>(
      EDjangoAppsEndpoints.tradeOrders,
      'securities',
      query
    );
  }

  public static async getAccounts(fundID: string): Promise<CoreJsonAPIResponse<ITradeOrderAccount[]>> {
    return await super.get<ITradeOrderAccount[]>(EDjangoAppsEndpoints.tradeOrders, `${fundID}/accounts`);
  }
}
